import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { Box, Typography, Chip } from '@mui/material';
import { Build as ProcessIcon } from '@mui/icons-material';

const ProcessNode = ({ data, isConnectable, selected }) => {
  return (
    <Box
      sx={{
        padding: '12px 16px',
        borderRadius: '8px',
        background: selected 
          ? 'linear-gradient(45deg, #3B82F6 30%, #60A5FA 90%)' 
          : 'linear-gradient(45deg, #3B82F6 30%, #1E40AF 90%)',
        color: 'white',
        border: selected ? '2px solid #1D4ED8' : 'none',
        boxShadow: selected 
          ? '0 4px 20px rgba(59, 130, 246, 0.4)' 
          : '0 2px 15px rgba(59, 130, 246, 0.2)',
        minWidth: '160px',
        position: 'relative',
        transition: 'all 0.2s ease',
        '&:hover': {
          boxShadow: '0 4px 25px rgba(59, 130, 246, 0.3)',
          transform: 'translateY(-2px)'
        }
      }}
    >
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={isConnectable}
        style={{
          background: '#1E40AF',
          width: 10,
          height: 10,
          border: '2px solid #fff'
        }}
      />
      
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <ProcessIcon sx={{ fontSize: 22 }} />
        <Box sx={{ flexGrow: 1 }}>
          <Typography 
            variant="body2" 
            sx={{ 
              fontWeight: 600,
              fontSize: '0.9rem'
            }}
          >
            {data.label}
          </Typography>
          {data.description && (
            <Typography 
              variant="caption" 
              sx={{ 
                opacity: 0.9,
                display: 'block',
                mt: 0.5,
                fontSize: '0.7rem',
                lineHeight: 1.2
              }}
            >
              {data.description}
            </Typography>
          )}
        </Box>
      </Box>

      {/* Process status indicator */}
      <Box sx={{ mt: 1, display: 'flex', justifyContent: 'flex-end' }}>
        <Chip 
          label="Process" 
          size="small" 
          sx={{ 
            backgroundColor: 'rgba(255,255,255,0.2)',
            color: 'white',
            fontSize: '0.6rem',
            height: 18
          }} 
        />
      </Box>
      
      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable={isConnectable}
        style={{
          background: '#1E40AF',
          width: 10,
          height: 10,
          border: '2px solid #fff'
        }}
      />
    </Box>
  );
};

export default memo(ProcessNode);